import { render, staticRenderFns } from "./chineseDrug.vue?vue&type=template&id=6a650dc1&scoped=true"
import script from "./chineseDrug.vue?vue&type=script&lang=js"
export * from "./chineseDrug.vue?vue&type=script&lang=js"
import style0 from "./chineseDrug.vue?vue&type=style&index=0&id=6a650dc1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a650dc1",
  null
  
)

export default component.exports